import { Product } from '@typings';

export const getProductDetails = (store: Store): (Product.Full & Product.StandardRelation) | Empty.Object => store.productDetails.data;
export const getIsLoadingProductDetails = (store: Store) => store.productDetails.isLoadingProductDetails;
export const getHasProductDetailsFailed = (store: Store) => store.productDetails.hasProductDetailsFailed;
